import React, { useState, useContext } from 'react';
import { EnvironmentContext } from '../App';
import config from '../config';
import { detailToString } from '../utils/apiError';

export default function AdminDevToolsPage() {
  const { envInfo } = useContext(EnvironmentContext);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Only render in dev environment
  if (!envInfo || envInfo.ui !== 'dev') {
    return (
      <div className="container my-4">
        <div className="alert alert-warning">Dev Tools are only available in the dev environment.</div>
      </div>
    );
  }

  async function handleRefreshDevDB() {
    setIsRefreshing(true);
    setMessage('');
    setError('');

    try {
      const res = await fetch(`${config.API_BASE_URL}/dev/refresh-db`, {
        method: 'POST',
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(detailToString(data.detail) || `Request failed: ${res.status}`);
      }

      const data = await res.json();
      setMessage(data.message);
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setIsRefreshing(false);
    }
  }

  return (
    <div className="container my-4">
      <h2><i className="fas fa-tools me-2"></i>Dev Tools</h2>
      <p className="text-muted">Development-only utilities. These tools are not available in production.</p>

      <div className="card p-4 mt-4">
        <h5><i className="fas fa-database me-2"></i>Refresh Dev Database</h5>
        <p className="text-muted mb-3">
          Clone the production database to dev using Aurora copy-on-write. This takes ~15 minutes
          and will cause brief dev DB downtime. You'll receive a Slack notification when it's complete.
        </p>
        <button
          className="btn btn-warning"
          onClick={handleRefreshDevDB}
          disabled={isRefreshing}
          style={{ width: 'fit-content' }}
        >
          {isRefreshing ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Triggering...
            </>
          ) : (
            <>
              <i className="fas fa-sync me-2"></i>
              Refresh Dev DB from Production
            </>
          )}
        </button>

        {message && (
          <div className="alert alert-success mt-3">
            <i className="fas fa-check-circle me-2"></i>{message}
          </div>
        )}
        {error && (
          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>{error}
          </div>
        )}
      </div>
    </div>
  );
}
